<div class="ss-form-input"
     [class.ss-input-error]="error"
     [class.ss-form-input-editor]="editor"
     [class.ss-form-input-textarea]="area"
     [class.ss-form-input-select]="select">
    <ng-content></ng-content>
</div>
